/**
 * Formats a number value as currency with symbol based on the currency symbol
 * @param value - The numeric value to format
 * @param currencySymbol - The currency symbol (€, $, £, etc.)
 * @returns Formatted currency string with symbol (e.g., "€10,50" or "$10.50")
 */
export const formatCurrency = (value: number | string | null | undefined, currencySymbol: string): string => {
	if (value === null || value === undefined) return `${currencySymbol}0.00`;

	const numValue = parseFloat(String(value));

	if (isNaN(numValue)) return `${currencySymbol}0.00`;

	const locale = {
		"€": "de-DE",
		"$": "en-US",
		"£": "en-US",
	}[currencySymbol];

	// Format based on currency symbol
	return `${currencySymbol}${numValue.toLocaleString(locale, {
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
	})}`;
};
